import { toast } from 'react-toastify';

import {
  fetchServiceOrders,
  fetchResumeOrders,
  fetchExport,
  fetchPaidServiceOrders
} from './services';

import {
  setServiceOrders,
  setResumeOrders,
  handleLoading,
  handleResumeLoading,
  setPaidServiceOrders,
  handlePaidServiceOrdersLoading
} from './actions';

import { handleExporting } from '../../../components/Filter/store/actions';

export const loadServiceOrders = ({ page, qp = '', extraProps }) => dispatch => {
  const { startDate, endDate, exportation, userId, establishmentId } = extraProps;

  let url = `${userId}/serviceorders/list?startDate=${startDate}&endDate=${endDate}&page=${page}${qp}`;

  if(establishmentId) {
    url = `${userId}/establishment/${establishmentId}/serviceorders/list?startDate=${startDate}&endDate=${endDate}&page=${page}${qp}`;
  }

  if(exportation) {
    dispatch(handleExporting(true));

    url = `/serviceorders?startDate=${startDate}&endDate=${endDate}&page=${page}${qp}`;

    return fetchServiceOrders(url)
      .then(({ data }) => {
        dispatch(handleExporting(false));
        return data;
      })
      .catch(() => dispatch(handleExporting(false)));
  }

  dispatch(handleLoading(true));

  return fetchServiceOrders(url)
    .then(({ data }) => {
      dispatch(setServiceOrders(data.content, data.total));
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadResumeOrders = (userId, establishmentId, qp, extraProps) => dispatch => {
  dispatch(handleResumeLoading(true));

  const { startDate, endDate } = extraProps;

  let url = `${userId}/establishment/${establishmentId}/serviceorders/resume?startDate=${startDate}&endDate=${endDate}`;

  if(extraProps) {
    url = `${userId}/establishment/${establishmentId}/serviceorders/resume?startDate=${startDate}&endDate=${endDate}${qp}`;
  }

  if(!establishmentId) {
    url = `${userId}/serviceorders/resume?startDate=${startDate}&endDate=${endDate}`;

    if(extraProps) {
      url = `${userId}/serviceorders/resume?startDate=${startDate}&endDate=${endDate}${qp}`;
    }
  }

  return fetchResumeOrders(url)
    .then(({ data }) => {
      dispatch(setResumeOrders(data));
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleResumeLoading(false)));
}

export const loadExport = (userId, establishmentId, extraProps, isCsv = false) => dispatch => {
  dispatch(handleExporting(true));

  return fetchExport(userId, establishmentId, extraProps)
    .then(({ data }) => {
      if(isCsv) {
        return data;
      }

      return Promise.resolve(data);
    })
    .catch(() => {
      toast.error('Não foi possível realizar a exportação.');
      return Promise.reject({});
    })
    .finally(() => dispatch(handleExporting(false)));
}

export const loadPaidServiceOrders = (userId, establishmentId) => dispatch => {
  dispatch(handlePaidServiceOrdersLoading(true));

  return fetchPaidServiceOrders(userId, establishmentId)
    .then(({ data }) => dispatch(setPaidServiceOrders(data)))
    .finally(() => dispatch(handlePaidServiceOrdersLoading(false)));
}